import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, map, take, timeout, catchError } from 'rxjs/operators';
import { NavigationService } from '../services/navigation.service';
import { AuthService } from '../services/auth.service';
import { canAccessRoute } from './route-access.util';

@Injectable({
  providedIn: 'root'
})
export class NavigationRouteGuard implements CanActivate {
  constructor(
    private navigationService: NavigationService,
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | boolean {
    if (canAccessRoute(route, this.authService, this.navigationService)) {
      return true;
    }

    if (!this.navigationService.menuLoaded) {
      return this.navigationService.menuLoaded$.pipe(
        filter(loaded => loaded),
        take(1),
        timeout(8000),
        map(() => this.finish(route)),
        catchError(() => of(this.finish(route)))
      );
    }

    return this.finish(route);
  }

  private finish(route: ActivatedRouteSnapshot): boolean {
    if (canAccessRoute(route, this.authService, this.navigationService)) {
      return true;
    }

    const target =
      this.navigationService.logoRoute ||
      this.navigationService.currentMenu.allowedRoutes?.[0] ||
      this.authService.getFirstAvailableRoute();
    this.router.navigate([target]);
    return false;
  }
}
